module.exports = __webpack_public_path__ + "img/law3m.7dce747d.webp";